import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

const BASE_URL = import.meta.env.VITE_API_BASE_URL;

// eslint-disable-next-line import/prefer-default-export
export const useThemeQuery = (project_id?: string) =>
  useQuery({
    queryFn: () => axios.get(`${BASE_URL}/projects/${project_id}/theme`),
    queryKey: ['chat_themes_branding', { project_id }],
    enabled: !!project_id,
    select: (data) => data?.data,
  });
